import { cn } from "@garther/ui/libs";

// Simple Badge component
interface BadgeProps {
  children: React.ReactNode;
  variant?: "default" | "secondary" | "outline";
  className?: string;
}

export function Badge({
  children,
  variant = "default",
  className,
}: BadgeProps) {
  const variantClasses = {
    default: "bg-background-dark-secondary text-text-inverse",
    secondary: "bg-background-secondary text-text-secondary",
    outline: "border border-border-dark text-text-primary bg-transparent",
  };

  return (
    <span
      className={cn(
        "inline-flex items-center px-2 py-1 text-responsive-sm font-medium rounded-md",
        variantClasses[variant],
        className
      )}
    >
      {children}
    </span>
  );
}
